import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import { useRoute, useRouter } from 'vue-router';
import { createKeyboardEventsFromLabel } from 'dashboard/components/widgets/modal/constants';

export function useSidebarKeyboardShortcuts(toggleShortcutModalFn) {
  const route = useRoute();
  const router = useRouter();

  const isCurrentRouteSameAsNavigation = routeName => {
    return route.name === routeName;
  };

  const navigateToRoute = routeName => {
    if (!isCurrentRouteSameAsNavigation(routeName)) {
      router.push({ name: routeName });
    }
  };
  const keyboardEvents = {
    'Control+Shift+Slash': {
      action: () => toggleShortcutModalFn(true),
    },
    'Control+Shift+Escape': {
      action: () => toggleShortcutModalFn(false),
    },
    ...createKeyboardEventsFromLabel('GO_TO_CONVERSATION_DASHBOARD', {
      action: () => navigateToRoute('home'),
    }),
    ...createKeyboardEventsFromLabel('GO_TO_CONTACTS_DASHBOARD', {
      action: () => navigateToRoute('contacts_dashboard_index'),
    }),
    ...createKeyboardEventsFromLabel('GO_TO_REPORTS_SIDEBAR', {
      action: () => navigateToRoute('account_overview_reports'),
    }),
    ...createKeyboardEventsFromLabel('GO_TO_SETTINGS', {
      action: () => navigateToRoute('agent_list'),
    }),
  };

  return useKeyboardEvents(keyboardEvents);
}
